/**
 * accountChooser.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";

//import IconButton from "@mui/material/IconButton";
//import Fab from "@mui/material/Fab";

import { AuthContext } from "../auth/auth.context";

import { SCAvatar } from "../components/avatar.component";

export function AccountChooser (): React.ReactElement<any, any> {
  const authContext = React.useContext(AuthContext);

  return  <nav className="account-chooser-container" data-testid="account-chooser">
    {authContext.memberships?.map(m => {
      let classes = "account-chooser-item-container";
      if (m._id === authContext.membership?._id) {
        classes += " selected";
      }
      return <div key={m.accountID} className={classes}
          onClick={() => authContext.setAccount(m)}>
        <div className="indicator"></div>
        <SCAvatar text={m.buttonText || "XX"} size="medium" />
      </div>;
    }) || []}
  </nav>;
}
